export const getUploadStatusColor = (status: UploadStatus) => {
  switch (status) {
    case "Uploading":
      return "primary";
    case "Completed":
      return "success";
    case "Failed":
      return "error";
    default:
      return undefined;
  }
};
